import { Link, useLocation } from 'react-router-dom';
import { 
  BookOpen, 
  Plus,
  Home,
  Sparkles
} from 'lucide-react';

export const Navbar: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-sm shadow-soft border-b border-purple-100">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link 
            to="/" 
            className="flex items-center space-x-2 text-xl font-elegant font-bold text-gradient hover:scale-105 transition-transform"
          >
            <Sparkles className="h-6 w-6 text-magical-purple" />
            <span>Générateur de Livres</span>
          </Link>

          {/* Navigation principale */}
          <div className="hidden md:flex items-center space-x-6">
            <Link 
              to="/dashboard"
              className={`flex items-center space-x-2 px-3 py-2 rounded-lg transition-all ${
                isActive('/dashboard') 
                  ? 'bg-primary-100 text-primary-700' 
                  : 'text-gray-600 hover:text-primary-600 hover:bg-primary-50'
              }`}
            >
              <Home className="h-4 w-4" />
              <span className="font-children">Mes Projets</span>
            </Link>

            <Link 
              to="/project/new"
              className={`flex items-center space-x-2 px-3 py-2 rounded-lg transition-all ${
                isActive('/project/new') 
                  ? 'bg-secondary-100 text-secondary-700' 
                  : 'text-gray-600 hover:text-secondary-600 hover:bg-secondary-50'
              }`}
            >
              <Plus className="h-4 w-4" />
              <span className="font-children">Nouveau Livre</span>
            </Link>
          </div>

          {/* Menu mobile (burger) */}
          <div className="md:hidden">
            {/* TODO: Implémenter le menu mobile responsive */}
            <button className="p-2 text-gray-600 hover:text-primary-600">
              <BookOpen className="h-6 w-6" />
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};
